export const CanvasCardStyle = {
  boxStyle: (backgroundColor = "#F6F7F9") => {
    return {
      width: "100%",
      height: "80px",
      borderRadius: "2px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: backgroundColor,
    };
  },
};
